module.exports = __webpack_public_path__ + "img/photo3_4.f4d1821e.jpg";